// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"LoginForm_formGroup__2JaYB","loginFooter":"LoginForm_loginFooter__2gEMH","link":"LoginForm_link__1378S","passwordLabel":"LoginForm_passwordLabel__2xdNb"};